import script from "./AppOTPField.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppOTPField.vue?vue&type=script&setup=true&lang=ts"

import "./AppOTPField.vue?vue&type=style&index=0&id=436ee6ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-436ee6ee"]])

export default __exports__